import { Props } from "chakra-react-select";
import { useController, UseControllerProps } from "react-hook-form";
import "./styles.css";
import BaseTimezoneSelect from "components/BaseTimezoneSelect";

interface TimezoneSelectProps {
  setDefault?: boolean;
}

type ControlledSelectProps = UseControllerProps & Props & TimezoneSelectProps;

function ControlledTimezone({
  control,
  name,
  rules,
  variant,
  placeholder,
  size = "md",
  setDefault = false,
  ...rest
}: ControlledSelectProps) {
  const {
    field: { onChange, onBlur, value },
  } = useController({
    name,
    control,
    rules,
    ...(setDefault ? { defaultValue: Intl.DateTimeFormat().resolvedOptions().timeZone } : {}),
  });

  const handleChange = (event: any) => {
    onChange(event.value);
  };

  return (
    <BaseTimezoneSelect
      value={value ?? ""}
      onBlur={onBlur}
      onChange={handleChange}
      menuPortalTarget={document.body}
      useBasicStyles
      size={size}
      name={name}
      variant={variant}
      className={value ? " chakra-react-select--has-value" : ""}
      placeholder={placeholder}
      {...rest}
    />
  );
}

export default ControlledTimezone;
